/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import * as api from "./restApi";
import * as t from "./public_api.generated.types";

function enc(s: any): string { return encodeURIComponent("" + s); }

export interface IPublicApi {
    /** Retrieve information about given operation */
    getOperationInfo(req: t.IGetOperationInfoReq): Promise<t.IGetOperationInfoRes>;

    /** Retrieve information about opened manual entry orders */
    getManualEntryOrders(req: t.IGetManualEntryOrdersReq): Promise<t.IGetManualEntryOrdersRes>;

    /** Retrieve information about given order */
    getOrderInfo(req: t.IGetOrderInfoReq): Promise<t.IGetOrderInfoRes>;

    /** Update person's presence */
    updatePersonPresence(req: t.IUpdatePersonPresenceReq): Promise<t.IUpdatePersonPresenceRes>;

    /** Retrieve absence for given person */
    getPersonAbsence(req: t.IGetPersonAbsenceReq): Promise<t.IGetPersonAbsenceRes>;

    /** Add person's absence (shifts: which day-shifts; omit shifts and shift for full day; shift deprecated) */
    addPersonAbsence(req: t.IAddPersonAbsenceReq): Promise<t.IAddPersonAbsenceRes>;

    /** Update person's absence (shifts: which day-shifts; omit both for full day; shift deprecated) */
    updatePersonAbsence(req: t.IUpdatePersonAbsenceReq): Promise<t.IUpdatePersonAbsenceRes>;

    /** Delete person's absence for a date (optional shifts query; omit to remove all absences for that day) */
    deletePersonAbsence(req: t.IDeletePersonAbsenceReq): Promise<t.IDeletePersonAbsenceRes>;

    /** Retrieve schedule for given person for given day */
    getPersonSchedule(req: t.IGetPersonScheduleReq): Promise<t.IGetPersonScheduleRes>;

    /** Retrieve competences for given person */
    getPersonCompetences(req: t.IGetPersonCompetencesReq): Promise<t.IGetPersonCompetencesRes>;

    /** Upsert competences for given person. Existing competences for other lines wont be affected */
    upsertPersonCompetences(req: t.IUpsertPersonCompetencesReq): Promise<t.IUpsertPersonCompetencesRes>;

    /** @deprecated Retrieve extended information about given person */
    getPersonInfo(req: t.IGetPersonInfoReq): Promise<t.IGetPersonInfoRes>;

    /** @deprecated Update information about given person */
    updatePersonInfo(req: t.IUpdatePersonInfoReq): Promise<t.IUpdatePersonInfoRes>;

    /** Retrieve basic info about people from the system */
    getPersonBasicInfo(req: t.IGetPersonBasicInfoReq): Promise<t.IGetPersonBasicInfoRes>;

    /** Insert new person into the system */
    insertPerson(req: t.IInsertPersonReq): Promise<t.IInsertPersonRes>;

    /** Retrieve information about single person */
    getPerson(req: t.IGetPersonReq): Promise<t.IGetPersonRes>;

    /** Update data about person */
    updatePerson(req: t.IUpdatePersonReq): Promise<t.IUpdatePersonRes>;

    /** Retrieve availability for given person */
    getPersonAvailability(req: t.IGetPersonAvailabilityReq): Promise<t.IGetPersonAvailabilityRes>;

    /** Insert availability for given person */
    insertPersonAvailability(req: t.IInsertPersonAvailabilityReq): Promise<t.IInsertPersonAvailabilityRes>;

    /** Delete availability for given person */
    deletePersonAvailability(req: t.IDeletePersonAvailabilityReq): Promise<t.IDeletePersonAvailabilityRes>;

    /** Retrieve information about single user */
    getUserInfo(req: t.IGetUserInfoReq): Promise<t.IGetUserInfoRes>;

    /** Update data about user */
    updateUser(req: t.IUpdateUserReq): Promise<t.IUpdateUserRes>;

    /** Get user list */
    getUsers(req: t.IGetUsersReq): Promise<t.IGetUsersRes>;

    /** Insert new user */
    insertUser(req: t.IInsertUserReq): Promise<t.IInsertUserRes>;

    /** Search basic information about plants */
    getPlants(req: t.IGetPlantsReq): Promise<t.IGetPlantsRes>;

    /** Inserts new plant */
    insertPlant(req: t.IInsertPlantReq): Promise<t.IInsertPlantRes>;

    /** Retrieve information about single plant */
    getPlantInfo(req: t.IGetPlantInfoReq): Promise<t.IGetPlantInfoRes>;

    /** Update data about plant */
    updatePlant(req: t.IUpdatePlantReq): Promise<t.IUpdatePlantRes>;

    /** Search basic information about lines */
    getLines(req: t.IGetLinesReq): Promise<t.IGetLinesRes>;

    /** Inserts new line */
    insertLine(req: t.IInsertLineReq): Promise<t.IInsertLineRes>;

    /** Retrieve information about single line */
    getLine(req: t.IGetLineReq): Promise<t.IGetLineRes>;

    /** Update data about line */
    updateLine(req: t.IUpdateLineReq): Promise<t.IUpdateLineRes>;

    /** Delete line - This is a cascade delete. All data connected to this item will be permanently removed. */
    deleteLine(req: t.IDeleteLineReq): Promise<t.IDeleteLineRes>;

    /** Retrieve scheduled orders for given line for given day */
    getLineSchedule(req: t.IGetLineScheduleReq): Promise<t.IGetLineScheduleRes>;

    /** Retrieve categories for given line */
    getLineCategories(req: t.IGetLineCategoriesReq): Promise<t.IGetLineCategoriesRes>;

    /** Add category item to line */
    addCategoryItemToLine(req: t.IAddCategoryItemToLineReq): Promise<t.IAddCategoryItemToLineRes>;

    /** Remove category item from line */
    removeCategoryItemFromLine(req: t.IRemoveCategoryItemFromLineReq): Promise<t.IRemoveCategoryItemFromLineRes>;

    /** Retrieve scheduled orders for given machine for given day */
    getMachineSchedule(req: t.IGetMachineScheduleReq): Promise<t.IGetMachineScheduleRes>;

    /** Get productions */
    getProductions(req: t.IGetProductionsReq): Promise<t.IGetProductionsRes>;

    /** Insert new production */
    insertProduction(req: t.IInsertProductionReq): Promise<t.IInsertProductionRes>;

    /** Get productions for material by produced_id */
    getLineProduced(req: t.IGetLineProducedReq): Promise<t.IGetLineProducedRes>;

    /** Update existing production on material */
    updateLineProduced(req: t.IUpdateLineProducedReq): Promise<t.IUpdateLineProducedRes>;

    /** Delete production on material */
    deleteLineProduced(req: t.IDeleteLineProducedReq): Promise<t.IDeleteLineProducedRes>;

    /** Retrieves pending tickets in user-steps assigned to specified user */
    ticketingGetUserInbox(req: t.ITicketingGetUserInboxReq): Promise<t.ITicketingGetUserInboxRes>;

    /** Retrieves current user-step info for given step and user */
    ticketingGetUserStepInfo(req: t.ITicketingGetUserStepInfoReq): Promise<t.ITicketingGetUserStepInfoRes>;

    /** Sends data to fulfill user-step for given step and user */
    ticketingCloseUserStep(req: t.ITicketingCloseUserStepReq): Promise<t.ITicketingCloseUserStepRes>;

    /** Retrieve calendars */
    getCalendars(req: t.IGetCalendarsReq): Promise<t.IGetCalendarsRes>;

    /** Insert new calendar */
    insertCalendar(req: t.IInsertCalendarReq): Promise<t.IInsertCalendarRes>;

    /** Retrieve information about single calendar */
    getCalendarInfo(req: t.IGetCalendarInfoReq): Promise<t.IGetCalendarInfoRes>;

    /** Update data about calendar */
    updateCalendar(req: t.IUpdateCalendarReq): Promise<t.IUpdateCalendarRes>;

    /** Delete calendar */
    deleteCalendar(req: t.IDeleteCalendarReq): Promise<t.IDeleteCalendarRes>;

    /** Retrieve list of events for given calendar */
    getEventsForCalendar(req: t.IGetEventsForCalendarReq): Promise<t.IGetEventsForCalendarRes>;

    /** Insert new event for calendar */
    insertEventForCalendar(req: t.IInsertEventForCalendarReq): Promise<t.IInsertEventForCalendarRes>;

    /** Retrieve information about single event in calendar */
    getCalendarEventInfo(req: t.IGetCalendarEventInfoReq): Promise<t.IGetCalendarEventInfoRes>;

    /** Update data about event in calendar */
    updateCalendarEvent(req: t.IUpdateCalendarEventReq): Promise<t.IUpdateCalendarEventRes>;

    /** Delete event from calendar */
    deleteEventFromCalendar(req: t.IDeleteEventFromCalendarReq): Promise<t.IDeleteEventFromCalendarRes>;

    /** Gets all competences */
    getCompetences(req: t.IGetCompetencesReq): Promise<t.IGetCompetencesRes>;

    /** Insert new competence */
    insertCompetence(req: t.IInsertCompetenceReq): Promise<t.IInsertCompetenceRes>;

    /** Get competence by competence_id */
    getCompetence(req: t.IGetCompetenceReq): Promise<t.IGetCompetenceRes>;

    /** Update existing competence */
    updateCompetence(req: t.IUpdateCompetenceReq): Promise<t.IUpdateCompetenceRes>;

    /** Delete competence */
    deleteCompetence(req: t.IDeleteCompetenceReq): Promise<t.IDeleteCompetenceRes>;

    /** Gets all product groups */
    getProductGroups(req: t.IGetProductGroupsReq): Promise<t.IGetProductGroupsRes>;

    /** Insert new product group */
    insertProductGroup(req: t.IInsertProductGroupReq): Promise<t.IInsertProductGroupRes>;

    /** Get product group by product_group_id */
    getProductGroup(req: t.IGetProductGroupReq): Promise<t.IGetProductGroupRes>;

    /** Update existing product group */
    updateProductGroup(req: t.IUpdateProductGroupReq): Promise<t.IUpdateProductGroupRes>;

    /** Delete product group */
    deleteProductGroup(req: t.IDeleteProductGroupReq): Promise<t.IDeleteProductGroupRes>;

    /** Get all materials in product group */
    getMaterialsInProductGroup(req: t.IGetMaterialsInProductGroupReq): Promise<t.IGetMaterialsInProductGroupRes>;

    /** Add material to product group */
    addMaterialToProductGroup(req: t.IAddMaterialToProductGroupReq): Promise<t.IAddMaterialToProductGroupRes>;

    /** Delete material from product group */
    deleteMaterialFromProductGroup(req: t.IDeleteMaterialFromProductGroupReq): Promise<t.IDeleteMaterialFromProductGroupRes>;

    /** Get all lines in product group */
    getLinesInProductGroup(req: t.IGetLinesInProductGroupReq): Promise<t.IGetLinesInProductGroupRes>;

    /** Add line to product group */
    addLineToProductGroup(req: t.IAddLineToProductGroupReq): Promise<t.IAddLineToProductGroupRes>;

    /** Delete line from product group */
    deleteLineFromProductGroup(req: t.IDeleteLineFromProductGroupReq): Promise<t.IDeleteLineFromProductGroupRes>;

    /** Get all plan sales in product group */
    getPlanSalesInProductGroup(req: t.IGetPlanSalesInProductGroupReq): Promise<t.IGetPlanSalesInProductGroupRes>;

    /** Insert new plan sale in product group */
    insertPlanSaleInProductGroup(req: t.IInsertPlanSaleInProductGroupReq): Promise<t.IInsertPlanSaleInProductGroupRes>;

    /** Get plan sales for product group */
    getPlanSalesForProductGroupByPlanSaleId(req: t.IGetPlanSalesForProductGroupByPlanSaleIdReq): Promise<t.IGetPlanSalesForProductGroupByPlanSaleIdRes>;

    /** Update existing plan sale on product group */
    updatePlanSaleOnProductGroupByPlanSaleId(req: t.IUpdatePlanSaleOnProductGroupByPlanSaleIdReq): Promise<t.IUpdatePlanSaleOnProductGroupByPlanSaleIdRes>;

    /** Delete plan sale on product group */
    deletePlanSaleOnProductGroupByPlanSaleId(req: t.IDeletePlanSaleOnProductGroupByPlanSaleIdReq): Promise<t.IDeletePlanSaleOnProductGroupByPlanSaleIdRes>;

    /** Gets all materials */
    getMaterials(req: t.IGetMaterialsReq): Promise<t.IGetMaterialsRes>;

    /** Insert new material */
    insertMaterial(req: t.IInsertMaterialReq): Promise<t.IInsertMaterialRes>;

    /** Get material by material_id */
    getMaterial(req: t.IGetMaterialReq): Promise<t.IGetMaterialRes>;

    /** Update existing material */
    updateMaterial(req: t.IUpdateMaterialReq): Promise<t.IUpdateMaterialRes>;

    /** Delete material */
    deleteMaterial(req: t.IDeleteMaterialReq): Promise<t.IDeleteMaterialRes>;

    /** Gets all cycle times */
    getCycleTimes(req: t.IGetCycleTimesReq): Promise<t.IGetCycleTimesRes>;

    /** Insert new cycle time */
    insertCycleTime(req: t.IInsertCycleTimeReq): Promise<t.IInsertCycleTimeRes>;

    /** Get cycle time by cycle_time_id */
    getCycleTime(req: t.IGetCycleTimeReq): Promise<t.IGetCycleTimeRes>;

    /** Update existing cycle time */
    updateCycleTime(req: t.IUpdateCycleTimeReq): Promise<t.IUpdateCycleTimeRes>;

    /** Delete cycle time */
    deleteCycleTime(req: t.IDeleteCycleTimeReq): Promise<t.IDeleteCycleTimeRes>;

    /** Get schedule for specific shift */
    getScheduleForShift(req: t.IGetScheduleForShiftReq): Promise<t.IGetScheduleForShiftRes>;

    /** Get schedule for specific worker */
    getScheduleForWorker(req: t.IGetScheduleForWorkerReq): Promise<t.IGetScheduleForWorkerRes>;

    /** Gets all line groups */
    getLineGroups(req: t.IGetLineGroupsReq): Promise<t.IGetLineGroupsRes>;

    /** Insert new line group */
    insertLineGroup(req: t.IInsertLineGroupReq): Promise<t.IInsertLineGroupRes>;

    /** Get line group by line_group_id */
    getLineGroup(req: t.IGetLineGroupReq): Promise<t.IGetLineGroupRes>;

    /** Update existing line group */
    updateLineGroup(req: t.IUpdateLineGroupReq): Promise<t.IUpdateLineGroupRes>;

    /** Delete line group */
    deleteLineGroup(req: t.IDeleteLineGroupReq): Promise<t.IDeleteLineGroupRes>;

    /** Get all lines in line group */
    getLinesInLineGroup(req: t.IGetLinesInLineGroupReq): Promise<t.IGetLinesInLineGroupRes>;

    /** Add line to line group */
    addLineToLineGroup(req: t.IAddLineToLineGroupReq): Promise<t.IAddLineToLineGroupRes>;

    /** Remove line from line group */
    removeLineFromLineGroup(req: t.IRemoveLineFromLineGroupReq): Promise<t.IRemoveLineFromLineGroupRes>;

    /** Get events */
    getEvents(req: t.IGetEventsReq): Promise<t.IGetEventsRes>;

    /** Get webhook subscriptions */
    getWebhooks(req: t.IGetWebhooksReq): Promise<t.IGetWebhooksRes>;

    /** Add new webhook subscription */
    createWebhook(req: t.ICreateWebhookReq): Promise<t.ICreateWebhookRes>;

    /** Delete webhook subscription */
    deleteWebhook(req: t.IDeleteWebhookReq): Promise<t.IDeleteWebhookRes>;

    /** Get all categories */
    getCategories(req: t.IGetCategoriesReq): Promise<t.IGetCategoriesRes>;

    /** Insert new category */
    insertCategory(req: t.IInsertCategoryReq): Promise<t.IInsertCategoryRes>;

    /** Get category by category_id */
    getCategory(req: t.IGetCategoryReq): Promise<t.IGetCategoryRes>;

    /** Update existing category */
    updateCategory(req: t.IUpdateCategoryReq): Promise<t.IUpdateCategoryRes>;

    /** Delete category */
    deleteCategory(req: t.IDeleteCategoryReq): Promise<t.IDeleteCategoryRes>;

}

export class PublicApi implements IPublicApi {

    client: api.ApiClient;

    constructor(client: api.ApiClient) { this.client = client; }

    /** Retrieve information about given operation */
    async getOperationInfo(req: t.IGetOperationInfoReq): Promise<t.IGetOperationInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/operation/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Retrieve information about opened manual entry orders */
    async getManualEntryOrders(req: t.IGetManualEntryOrdersReq): Promise<t.IGetManualEntryOrdersRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/manual-orders`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Retrieve information about given order */
    async getOrderInfo(req: t.IGetOrderInfoReq): Promise<t.IGetOrderInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/order/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update person's presence */
    async updatePersonPresence(req: t.IUpdatePersonPresenceReq): Promise<t.IUpdatePersonPresenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.id)}/presence`;
        delete reqx.id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve absence for given person */
    async getPersonAbsence(req: t.IGetPersonAbsenceReq): Promise<t.IGetPersonAbsenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/absence`;
        delete reqx.person_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Add person's absence (shifts: which day-shifts; omit shifts and shift for full day; shift deprecated) */
    async addPersonAbsence(req: t.IAddPersonAbsenceReq): Promise<t.IAddPersonAbsenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/absence`;
        delete reqx.person_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Update person's absence (shifts: which day-shifts; omit both for full day; shift deprecated) */
    async updatePersonAbsence(req: t.IUpdatePersonAbsenceReq): Promise<t.IUpdatePersonAbsenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/absence`;
        delete reqx.person_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete person's absence for a date (optional shifts query; omit to remove all absences for that day) */
    async deletePersonAbsence(req: t.IDeletePersonAbsenceReq): Promise<t.IDeletePersonAbsenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/absence`;
        delete reqx.person_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Retrieve schedule for given person for given day */
    async getPersonSchedule(req: t.IGetPersonScheduleReq): Promise<t.IGetPersonScheduleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.id)}/schedule`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Retrieve competences for given person */
    async getPersonCompetences(req: t.IGetPersonCompetencesReq): Promise<t.IGetPersonCompetencesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.id)}/competences`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Upsert competences for given person. Existing competences for other lines wont be affected */
    async upsertPersonCompetences(req: t.IUpsertPersonCompetencesReq): Promise<t.IUpsertPersonCompetencesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.id)}/competences`;
        delete reqx.id;
        return (await this.client.post(url, reqx)).data;
    }

    /** @deprecated Retrieve extended information about given person */
    async getPersonInfo(req: t.IGetPersonInfoReq): Promise<t.IGetPersonInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.id)}/info`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** @deprecated Update information about given person */
    async updatePersonInfo(req: t.IUpdatePersonInfoReq): Promise<t.IUpdatePersonInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.id)}/update`;
        delete reqx.id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve basic info about people from the system */
    async getPersonBasicInfo(req: t.IGetPersonBasicInfoReq): Promise<t.IGetPersonBasicInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new person into the system */
    async insertPerson(req: t.IInsertPersonReq): Promise<t.IInsertPersonRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve information about single person */
    async getPerson(req: t.IGetPersonReq): Promise<t.IGetPersonRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}`;
        delete reqx.person_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update data about person */
    async updatePerson(req: t.IUpdatePersonReq): Promise<t.IUpdatePersonRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}`;
        delete reqx.person_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Retrieve availability for given person */
    async getPersonAvailability(req: t.IGetPersonAvailabilityReq): Promise<t.IGetPersonAvailabilityRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/availability`;
        delete reqx.person_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert availability for given person */
    async insertPersonAvailability(req: t.IInsertPersonAvailabilityReq): Promise<t.IInsertPersonAvailabilityRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/availability`;
        delete reqx.person_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Delete availability for given person */
    async deletePersonAvailability(req: t.IDeletePersonAvailabilityReq): Promise<t.IDeletePersonAvailabilityRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/people/${enc(req.person_id)}/availability/${enc(req.availability_id)}`;
        delete reqx.person_id;
        delete reqx.availability_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Retrieve information about single user */
    async getUserInfo(req: t.IGetUserInfoReq): Promise<t.IGetUserInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/users/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update data about user */
    async updateUser(req: t.IUpdateUserReq): Promise<t.IUpdateUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/users/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get user list */
    async getUsers(req: t.IGetUsersReq): Promise<t.IGetUsersRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/users`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new user */
    async insertUser(req: t.IInsertUserReq): Promise<t.IInsertUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/users`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Search basic information about plants */
    async getPlants(req: t.IGetPlantsReq): Promise<t.IGetPlantsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/plant`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Inserts new plant */
    async insertPlant(req: t.IInsertPlantReq): Promise<t.IInsertPlantRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/plant`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve information about single plant */
    async getPlantInfo(req: t.IGetPlantInfoReq): Promise<t.IGetPlantInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/plant/${enc(req.plant_id)}`;
        delete reqx.plant_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update data about plant */
    async updatePlant(req: t.IUpdatePlantReq): Promise<t.IUpdatePlantRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/plant/${enc(req.plant_id)}`;
        delete reqx.plant_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Search basic information about lines */
    async getLines(req: t.IGetLinesReq): Promise<t.IGetLinesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Inserts new line */
    async insertLine(req: t.IInsertLineReq): Promise<t.IInsertLineRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve information about single line */
    async getLine(req: t.IGetLineReq): Promise<t.IGetLineRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}`;
        delete reqx.line_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update data about line */
    async updateLine(req: t.IUpdateLineReq): Promise<t.IUpdateLineRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}`;
        delete reqx.line_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete line - This is a cascade delete. All data connected to this item will be permanently removed. */
    async deleteLine(req: t.IDeleteLineReq): Promise<t.IDeleteLineRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}`;
        delete reqx.line_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Retrieve scheduled orders for given line for given day */
    async getLineSchedule(req: t.IGetLineScheduleReq): Promise<t.IGetLineScheduleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.id)}/schedule`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Retrieve categories for given line */
    async getLineCategories(req: t.IGetLineCategoriesReq): Promise<t.IGetLineCategoriesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/categories`;
        delete reqx.line_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Add category item to line */
    async addCategoryItemToLine(req: t.IAddCategoryItemToLineReq): Promise<t.IAddCategoryItemToLineRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/categories/${enc(req.category_id)}/${enc(req.category_item_id)}`;
        delete reqx.line_id;
        delete reqx.category_id;
        delete reqx.category_item_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Remove category item from line */
    async removeCategoryItemFromLine(req: t.IRemoveCategoryItemFromLineReq): Promise<t.IRemoveCategoryItemFromLineRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/categories/${enc(req.category_id)}/${enc(req.category_item_id)}`;
        delete reqx.line_id;
        delete reqx.category_id;
        delete reqx.category_item_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Retrieve scheduled orders for given machine for given day */
    async getMachineSchedule(req: t.IGetMachineScheduleReq): Promise<t.IGetMachineScheduleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/machine/${enc(req.id)}/schedule`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Get productions */
    async getProductions(req: t.IGetProductionsReq): Promise<t.IGetProductionsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/productions`;
        delete reqx.line_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new production */
    async insertProduction(req: t.IInsertProductionReq): Promise<t.IInsertProductionRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/productions`;
        delete reqx.line_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get productions for material by produced_id */
    async getLineProduced(req: t.IGetLineProducedReq): Promise<t.IGetLineProducedRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/productions/${enc(req.produced_id)}`;
        delete reqx.line_id;
        delete reqx.produced_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing production on material */
    async updateLineProduced(req: t.IUpdateLineProducedReq): Promise<t.IUpdateLineProducedRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/productions/${enc(req.produced_id)}`;
        delete reqx.line_id;
        delete reqx.produced_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete production on material */
    async deleteLineProduced(req: t.IDeleteLineProducedReq): Promise<t.IDeleteLineProducedRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line/${enc(req.line_id)}/productions/${enc(req.produced_id)}`;
        delete reqx.line_id;
        delete reqx.produced_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Retrieves pending tickets in user-steps assigned to specified user */
    async ticketingGetUserInbox(req: t.ITicketingGetUserInboxReq): Promise<t.ITicketingGetUserInboxRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/ticketing/inbox`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Retrieves current user-step info for given step and user */
    async ticketingGetUserStepInfo(req: t.ITicketingGetUserStepInfoReq): Promise<t.ITicketingGetUserStepInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/ticketing/ticket/${enc(req.uuid)}/user-step`;
        delete reqx.uuid;
        return (await this.client.get(url, reqx)).data;
    }

    /** Sends data to fulfill user-step for given step and user */
    async ticketingCloseUserStep(req: t.ITicketingCloseUserStepReq): Promise<t.ITicketingCloseUserStepRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/ticketing/ticket/${enc(req.uuid)}/user-step`;
        delete reqx.uuid;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve calendars */
    async getCalendars(req: t.IGetCalendarsReq): Promise<t.IGetCalendarsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new calendar */
    async insertCalendar(req: t.IInsertCalendarReq): Promise<t.IInsertCalendarRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve information about single calendar */
    async getCalendarInfo(req: t.IGetCalendarInfoReq): Promise<t.IGetCalendarInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}`;
        delete reqx.calendar_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update data about calendar */
    async updateCalendar(req: t.IUpdateCalendarReq): Promise<t.IUpdateCalendarRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}`;
        delete reqx.calendar_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete calendar */
    async deleteCalendar(req: t.IDeleteCalendarReq): Promise<t.IDeleteCalendarRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}`;
        delete reqx.calendar_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Retrieve list of events for given calendar */
    async getEventsForCalendar(req: t.IGetEventsForCalendarReq): Promise<t.IGetEventsForCalendarRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}/events`;
        delete reqx.calendar_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new event for calendar */
    async insertEventForCalendar(req: t.IInsertEventForCalendarReq): Promise<t.IInsertEventForCalendarRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}/events`;
        delete reqx.calendar_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Retrieve information about single event in calendar */
    async getCalendarEventInfo(req: t.IGetCalendarEventInfoReq): Promise<t.IGetCalendarEventInfoRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}/events/${enc(req.event_id)}`;
        delete reqx.calendar_id;
        delete reqx.event_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update data about event in calendar */
    async updateCalendarEvent(req: t.IUpdateCalendarEventReq): Promise<t.IUpdateCalendarEventRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}/events/${enc(req.event_id)}`;
        delete reqx.calendar_id;
        delete reqx.event_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete event from calendar */
    async deleteEventFromCalendar(req: t.IDeleteEventFromCalendarReq): Promise<t.IDeleteEventFromCalendarRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/calendars/${enc(req.calendar_id)}/events/${enc(req.event_id)}`;
        delete reqx.calendar_id;
        delete reqx.event_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Gets all competences */
    async getCompetences(req: t.IGetCompetencesReq): Promise<t.IGetCompetencesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/competence`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new competence */
    async insertCompetence(req: t.IInsertCompetenceReq): Promise<t.IInsertCompetenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/competence`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get competence by competence_id */
    async getCompetence(req: t.IGetCompetenceReq): Promise<t.IGetCompetenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/competence/${enc(req.competence_id)}`;
        delete reqx.competence_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing competence */
    async updateCompetence(req: t.IUpdateCompetenceReq): Promise<t.IUpdateCompetenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/competence/${enc(req.competence_id)}`;
        delete reqx.competence_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete competence */
    async deleteCompetence(req: t.IDeleteCompetenceReq): Promise<t.IDeleteCompetenceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/competence/${enc(req.competence_id)}`;
        delete reqx.competence_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Gets all product groups */
    async getProductGroups(req: t.IGetProductGroupsReq): Promise<t.IGetProductGroupsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new product group */
    async insertProductGroup(req: t.IInsertProductGroupReq): Promise<t.IInsertProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get product group by product_group_id */
    async getProductGroup(req: t.IGetProductGroupReq): Promise<t.IGetProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}`;
        delete reqx.product_group_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing product group */
    async updateProductGroup(req: t.IUpdateProductGroupReq): Promise<t.IUpdateProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}`;
        delete reqx.product_group_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete product group */
    async deleteProductGroup(req: t.IDeleteProductGroupReq): Promise<t.IDeleteProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}`;
        delete reqx.product_group_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get all materials in product group */
    async getMaterialsInProductGroup(req: t.IGetMaterialsInProductGroupReq): Promise<t.IGetMaterialsInProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/materials`;
        delete reqx.product_group_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Add material to product group */
    async addMaterialToProductGroup(req: t.IAddMaterialToProductGroupReq): Promise<t.IAddMaterialToProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/materials/${enc(req.material_id)}`;
        delete reqx.product_group_id;
        delete reqx.material_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Delete material from product group */
    async deleteMaterialFromProductGroup(req: t.IDeleteMaterialFromProductGroupReq): Promise<t.IDeleteMaterialFromProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/materials/${enc(req.material_id)}`;
        delete reqx.product_group_id;
        delete reqx.material_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get all lines in product group */
    async getLinesInProductGroup(req: t.IGetLinesInProductGroupReq): Promise<t.IGetLinesInProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/lines`;
        delete reqx.product_group_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Add line to product group */
    async addLineToProductGroup(req: t.IAddLineToProductGroupReq): Promise<t.IAddLineToProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/lines/${enc(req.line_id)}`;
        delete reqx.product_group_id;
        delete reqx.line_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Delete line from product group */
    async deleteLineFromProductGroup(req: t.IDeleteLineFromProductGroupReq): Promise<t.IDeleteLineFromProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/lines/${enc(req.line_id)}`;
        delete reqx.product_group_id;
        delete reqx.line_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get all plan sales in product group */
    async getPlanSalesInProductGroup(req: t.IGetPlanSalesInProductGroupReq): Promise<t.IGetPlanSalesInProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/plan-sales`;
        delete reqx.product_group_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new plan sale in product group */
    async insertPlanSaleInProductGroup(req: t.IInsertPlanSaleInProductGroupReq): Promise<t.IInsertPlanSaleInProductGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/plan-sales`;
        delete reqx.product_group_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get plan sales for product group */
    async getPlanSalesForProductGroupByPlanSaleId(req: t.IGetPlanSalesForProductGroupByPlanSaleIdReq): Promise<t.IGetPlanSalesForProductGroupByPlanSaleIdRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/plan-sales/${enc(req.plan_sale_id)}`;
        delete reqx.product_group_id;
        delete reqx.plan_sale_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing plan sale on product group */
    async updatePlanSaleOnProductGroupByPlanSaleId(req: t.IUpdatePlanSaleOnProductGroupByPlanSaleIdReq): Promise<t.IUpdatePlanSaleOnProductGroupByPlanSaleIdRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/plan-sales/${enc(req.plan_sale_id)}`;
        delete reqx.product_group_id;
        delete reqx.plan_sale_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete plan sale on product group */
    async deletePlanSaleOnProductGroupByPlanSaleId(req: t.IDeletePlanSaleOnProductGroupByPlanSaleIdReq): Promise<t.IDeletePlanSaleOnProductGroupByPlanSaleIdRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/product-groups/${enc(req.product_group_id)}/plan-sales/${enc(req.plan_sale_id)}`;
        delete reqx.product_group_id;
        delete reqx.plan_sale_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Gets all materials */
    async getMaterials(req: t.IGetMaterialsReq): Promise<t.IGetMaterialsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/materials`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new material */
    async insertMaterial(req: t.IInsertMaterialReq): Promise<t.IInsertMaterialRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/materials`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get material by material_id */
    async getMaterial(req: t.IGetMaterialReq): Promise<t.IGetMaterialRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/materials/${enc(req.material_id)}`;
        delete reqx.material_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing material */
    async updateMaterial(req: t.IUpdateMaterialReq): Promise<t.IUpdateMaterialRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/materials/${enc(req.material_id)}`;
        delete reqx.material_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete material */
    async deleteMaterial(req: t.IDeleteMaterialReq): Promise<t.IDeleteMaterialRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/materials/${enc(req.material_id)}`;
        delete reqx.material_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Gets all cycle times */
    async getCycleTimes(req: t.IGetCycleTimesReq): Promise<t.IGetCycleTimesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/cycle-times`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new cycle time */
    async insertCycleTime(req: t.IInsertCycleTimeReq): Promise<t.IInsertCycleTimeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/cycle-times`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get cycle time by cycle_time_id */
    async getCycleTime(req: t.IGetCycleTimeReq): Promise<t.IGetCycleTimeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/cycle-times/${enc(req.cycle_time_id)}`;
        delete reqx.cycle_time_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing cycle time */
    async updateCycleTime(req: t.IUpdateCycleTimeReq): Promise<t.IUpdateCycleTimeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/cycle-times/${enc(req.cycle_time_id)}`;
        delete reqx.cycle_time_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete cycle time */
    async deleteCycleTime(req: t.IDeleteCycleTimeReq): Promise<t.IDeleteCycleTimeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/cycle-times/${enc(req.cycle_time_id)}`;
        delete reqx.cycle_time_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get schedule for specific shift */
    async getScheduleForShift(req: t.IGetScheduleForShiftReq): Promise<t.IGetScheduleForShiftRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/schedule/shift`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Get schedule for specific worker */
    async getScheduleForWorker(req: t.IGetScheduleForWorkerReq): Promise<t.IGetScheduleForWorkerRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/schedule/worker`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Gets all line groups */
    async getLineGroups(req: t.IGetLineGroupsReq): Promise<t.IGetLineGroupsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new line group */
    async insertLineGroup(req: t.IInsertLineGroupReq): Promise<t.IInsertLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get line group by line_group_id */
    async getLineGroup(req: t.IGetLineGroupReq): Promise<t.IGetLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups/${enc(req.line_group_id)}`;
        delete reqx.line_group_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing line group */
    async updateLineGroup(req: t.IUpdateLineGroupReq): Promise<t.IUpdateLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups/${enc(req.line_group_id)}`;
        delete reqx.line_group_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete line group */
    async deleteLineGroup(req: t.IDeleteLineGroupReq): Promise<t.IDeleteLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups/${enc(req.line_group_id)}`;
        delete reqx.line_group_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get all lines in line group */
    async getLinesInLineGroup(req: t.IGetLinesInLineGroupReq): Promise<t.IGetLinesInLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups/${enc(req.line_group_id)}/lines`;
        delete reqx.line_group_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Add line to line group */
    async addLineToLineGroup(req: t.IAddLineToLineGroupReq): Promise<t.IAddLineToLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups/${enc(req.line_group_id)}/lines/${enc(req.line_id)}`;
        delete reqx.line_group_id;
        delete reqx.line_id;
        return (await this.client.post(url, reqx)).data;
    }

    /** Remove line from line group */
    async removeLineFromLineGroup(req: t.IRemoveLineFromLineGroupReq): Promise<t.IRemoveLineFromLineGroupRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/line-groups/${enc(req.line_group_id)}/lines/${enc(req.line_id)}`;
        delete reqx.line_group_id;
        delete reqx.line_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get events */
    async getEvents(req: t.IGetEventsReq): Promise<t.IGetEventsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/events`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Get webhook subscriptions */
    async getWebhooks(req: t.IGetWebhooksReq): Promise<t.IGetWebhooksRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/events/webhooks`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Add new webhook subscription */
    async createWebhook(req: t.ICreateWebhookReq): Promise<t.ICreateWebhookRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/events/webhooks`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Delete webhook subscription */
    async deleteWebhook(req: t.IDeleteWebhookReq): Promise<t.IDeleteWebhookRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/events/webhooks/${enc(req.webhook_id)}`;
        delete reqx.webhook_id;
        return (await this.client.delete(url, reqx)).data;
    }

    /** Get all categories */
    async getCategories(req: t.IGetCategoriesReq): Promise<t.IGetCategoriesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/categories`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Insert new category */
    async insertCategory(req: t.IInsertCategoryReq): Promise<t.IInsertCategoryRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/categories`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get category by category_id */
    async getCategory(req: t.IGetCategoryReq): Promise<t.IGetCategoryRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/categories/${enc(req.category_id)}`;
        delete reqx.category_id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Update existing category */
    async updateCategory(req: t.IUpdateCategoryReq): Promise<t.IUpdateCategoryRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/categories/${enc(req.category_id)}`;
        delete reqx.category_id;
        return (await this.client.put(url, reqx)).data;
    }

    /** Delete category */
    async deleteCategory(req: t.IDeleteCategoryReq): Promise<t.IDeleteCategoryRes> {
        const reqx: any = req;
        const url = `/api/v1.0/public_api/categories/${enc(req.category_id)}`;
        delete reqx.category_id;
        return (await this.client.delete(url, reqx)).data;
    }

}
